import React from 'react';
import _ from 'lodash';
import cx from 'classnames';

import Input from 'components/forms/Input';
import { DownChevronIcon } from 'components/Svg';


// ====================
// SELECT INPUT
// ====================

export const SelectItem = ({ value, children }) => (
  <option value={value}>{children}</option>
)


export const SelectInput = React.forwardRef(({ className, children, ...props }, ref) => (
  <Input
    {...props}
    ref={ref}
    className={cx("select", className)}
    renderInput={inputProps => (
      <>
        <DownChevronIcon />
        <select {...inputProps} children={children} />
      </>
    )} />
))
export default SelectInput;